import React, { useEffect } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { CHANGE_DEVICE_STATUS_CODE, DATE_FORMAT_DISPLAY, DATE_FORMAT_VALUE, DEFAULT_FORMAT, STATUS_PENDING } from '@constants';
import { deviceStatus, orderDisplayLayouts } from '@constants/masterData';
import useAuth from '@hooks/useAuth';
import useBasicForm from '@hooks/useBasicForm';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, DatePickerField, SelectField, TextField } from '@itz/react-cms-element';
import { Card, Col, Row } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const message = defineMessages({
    requiredExpireDate: 'Expiration date is required',
    expireDateMustBeFuture: 'Expiration date must be a future date',
});

const DeviceOrderForm = ({ formId, actions, dataDetail, onSubmit, setIsChangedFormValues, isEditing }) => {
    const translate = useTranslate();
    const statusValues = translate.formatKeys(deviceStatus, ['label']);
    const layoutValues = translate.formatKeys(orderDisplayLayouts, ['label']);
    const { profile } = useAuth();

    const permissionCodes = profile?.group?.permissions?.map((permission) => permission.pcode);
    const hasPermissionCode = permissionCodes?.includes(CHANGE_DEVICE_STATUS_CODE);

    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const params = useParams();
    const handleSubmit = (values) => {
        values.customerId = params.customerId;
        if (values.expireDate) {
            values.expireDate = dayjs(values.expireDate).endOf('day').utc().format(DEFAULT_FORMAT);
        }

        values.type = 2;
        const finalValues = {
            ...values,
        };
        return mixinFuncs.handleSubmit(finalValues);
    };

    useEffect(() => {
        if (!isEditing) return;
        dataDetail.expireDate = dataDetail.expireDate && dayjs(dataDetail.expireDate, DATE_FORMAT_VALUE);
        form.setFieldsValue({
            ...dataDetail,
            status: dataDetail?.status,
        });
    }, [dataDetail]);

    useEffect(() => {
        if (!isEditing) {
            form.setFieldsValue({
                status: STATUS_PENDING,
            });
        }
    }, [isEditing]);

    return (
        <BaseForm id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                <Row gutter={10}>
                    <Col span={12}>
                        <TextField required label={<FormattedMessage defaultMessage="Device name" />} name="name" />
                    </Col>
                    <Col span={12}>
                        <TextField
                            required
                            label={<FormattedMessage defaultMessage="Device ID" />}
                            name="deviceId"
                            // disabled={isEditing}
                        />
                    </Col>
                </Row>
                <Row gutter={10}>
                    <Col span={12}>
                        <DatePickerField
                            label={<FormattedMessage defaultMessage="Expiration date" />}
                            name="expireDate"
                            format={DATE_FORMAT_DISPLAY}
                            disabledDate={(current) => current && current.isBefore(dayjs(), 'day')}
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: translate.formatMessage(message.requiredExpireDate),
                            //     },
                            //     {
                            //         validator: (_, value) => {
                            //             if (value && value.isBefore(dayjs(), 'day')) {
                            //                 return Promise.reject(translate.formatMessage(message.expireDateMustBeFuture));
                            //             }
                            //             return Promise.resolve();
                            //         },
                            //     },
                            // ]}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col span={12}>
                        <SelectField
                            label={<FormattedMessage defaultMessage="Layout" />}
                            name="layout"
                            required
                            options={layoutValues}
                        />
                    </Col>
                    <Col span={12}>
                        <SelectField
                            required
                            label={<FormattedMessage defaultMessage="Status" />}
                            name="status"
                            options={statusValues}
                            disabled={!hasPermissionCode}
                        />
                    </Col>
                </Row>
                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default DeviceOrderForm;
